





// Entry for all live helpers, (/live-helpers)
import { defineComponent, onMounted, ref } from '@vue/composition-api';

import useAuth from '@/useAuth';

const AppLivePlatform = defineComponent({
  setup() {
    const { getMe, hasPermission } = useAuth();
    const me = ref({});
    onMounted(async () => {
      me.value = await getMe();
    });

    return {
      me,
      hasPermission,
    };
  },
});

export default AppLivePlatform;
